"use strict";
import { __module as v } from "./index.es288.js";
import R from "react";
import { __require as C } from "./index.es289.js";
var k;
function E() {
  return k ? v.exports : (k = 1, (function(p, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "useIntersection", {
      enumerable: !0,
      get: function() {
        return M;
      }
    });
    const f = R, _ = C(), g = typeof IntersectionObserver == "function", m = /* @__PURE__ */ new Map(), d = [];
    function q(r) {
      const t = {
        root: r.root || null,
        margin: r.rootMargin || ""
      }, u = d.find((c) => c.root === t.root && c.margin === t.margin);
      let e;
      if (u && (e = m.get(u), e))
        return e;
      const i = /* @__PURE__ */ new Map(), s = new IntersectionObserver((c) => {
        c.forEach((o) => {
          const l = i.get(o.target), b = o.isIntersecting || o.intersectionRatio > 0;
          l && b && l(b);
        });
      }, r);
      return e = {
        id: t,
        observer: s,
        elements: i
      }, d.push(t), m.set(t, e), e;
    }
    function O(r, t, u) {
      const { id: e, observer: i, elements: s } = q(u);
      return s.set(r, t), i.observe(r), function() {
        if (s.delete(r), i.unobserve(r), s.size === 0) {
          i.disconnect(), m.delete(e);
          const o = d.findIndex((l) => l.root === e.root && l.margin === e.margin);
          o > -1 && d.splice(o, 1);
        }
      };
    }
    function M(r) {
      let { rootRef: t, rootMargin: u, disabled: e } = r;
      const i = e || !g, [s, c] = (0, f.useState)(!1), o = (0, f.useRef)(null), l = (0, f.useCallback)((a) => {
        o.current = a;
      }, []);
      (0, f.useEffect)(() => {
        if (g) {
          if (i || s) return;
          const a = o.current;
          if (a && a.tagName)
            return O(a, (I) => I && c(I), {
              root: t?.current,
              rootMargin: u
            });
        } else if (!s) {
          const a = (0, _.requestIdleCallback)(() => c(!0));
          return () => (0, _.cancelIdleCallback)(a);
        }
      }, [
        i,
        u,
        t,
        s,
        o.current
      ]);
      const b = (0, f.useCallback)(() => {
        c(!1);
      }, []);
      return [
        l,
        s,
        b
      ];
    }
    (typeof n.default == "function" || typeof n.default == "object" && n.default !== null) && typeof n.default.__esModule > "u" && (Object.defineProperty(n.default, "__esModule", { value: !0 }), Object.assign(n.default, n), p.exports = n.default);
  })(v, v.exports), v.exports);
}
export {
  E as __require
};
//# sourceMappingURL=index.es256.js.map
